<template>
  <base-wrapper :loading="loadingCategories || form.loading || deleteConfirm.loading">
    <div class="space-y-4">
      <div class="flex items-center justify-end space-x-2">
        <base-button @click="onCreate" type="button">
          <Icon icon="heroicons:plus-20-solid" class="h-5 w-5" />
          Tambah Kategori
        </base-button>
      </div>
      <datatable
        :total="categories.meta.page.total"
        :perPage="categories.meta.page.perPage"
        :currentPage="categories.meta.page.currentPage"
        :columns="[
          { id: 'name', name: 'Kategori' },
          { id: 'action', name: 'Aksi' },
        ]"
        @pagechanged="onPageChange"
      >
        <template #tbody="{ classes }">
          <tr
            v-for="category in categories.data"
            :key="category.id"
            :class="[classes.tr, 'bg-white']"
          >
            <td :class="classes.td">{{ category.attributes.name }}</td>
            <td :class="[classes.td]">
              <div class="flex gap-1">
                <button
                  class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                  @click="onEdit(category)"
                >
                  <Icon icon="heroicons:pencil-square-solid" class="w-4 h-4" />
                </button>
                <button
                  class="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-gray-100"
                  @click="onDelete(category)"
                >
                  <Icon icon="heroicons:trash-solid" class="w-4 h-4" />
                </button>
              </div>
            </td>
          </tr>
        </template>
      </datatable>
    </div>

    <base-modal
      :showing="form.visible"
      @close="form.visible = false"
    >
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <div>
            <h3 class="text-lg font-bold leading-6 text-gray-900">
              {{ form.type === 'create' ? 'Tambah Kategori' : 'Edit Kategori' }}
            </h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              {{ form.type === 'create' ? 'Tambah Kategori Baru' : 'Edit Kategori' }}
            </p>
          </div>
        </div>
      </div>
      <form
        class="mt-6 space-y-4 border-t border-gray-200 pt-6"
        @submit.prevent="onSubmitForm"
      >
        <base-input
          label="Nama Kategori"
          :shadow="false"
          fullwidth
          placeholder="Nama Kategori"
          type="text"
          required
          v-model="form.name"
        />
        <div class="space-x-2">
          <base-button color="white" type="button" @click="form.visible = false"
            >Batal</base-button
          >
          <base-button>Simpan</base-button>
        </div>
      </form>
    </base-modal>

    <base-confirm
      :visible="deleteConfirm.visible"
      title="Hapus Kategori"
      message="Apakah anda yakin ingin menghapus kategori ini?"
      icon-type="badge"
      @close="deleteConfirm.visible = false"
      @confirmed="onConfirmDelete"
    />
  </base-wrapper>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import { requestMixin } from '@/mixins/request/request';
import BaseModal from '../../../../components/base/BaseModal.vue';
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../components/base/BaseConfirm.vue';

export default {
  name: 'Home',
  mixins: [requestMixin],
  components: {
    BaseButton,
    BaseModal,
    BaseConfirm
  },
  data() {
    return {
      loadingCategories: false,
      categories: {
        data: [],
        meta: {
          page: {},
        },
      },
      form: {
        visible: false,
        loading: false,
        type: 'create',
        name: null,
        editId: null
      },
      deleteConfirm: {
        visible: false,
        loading: false,
        id: null
      }
    };
  },
  created() {
    this.loadCategories();
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    onPageChange(page) {
      this.loadCategories({
        'page[number]': page
      });
    },
    onCreate() {
      this.form.type = 'create'
      this.form.name = null
      this.form.editId = null
      this.form.visible = true;
    },
    onEdit(category) {
      this.form.type = 'edit'
      this.form.name = category.attributes.name
      this.form.editId = category.id
      this.form.visible = true;
    },
    onDelete(category) {
      this.deleteConfirm.id = category.id
      this.deleteConfirm.visible = true
    },
    async onConfirmDelete() {
      this.deleteConfirm.loading = true;

      const [, error] = await this.request(`/api/v1/article-categories/${this.deleteConfirm.id}`, {
        method: 'delete'
      });

      if (!error) {
        this.deleteConfirm.visible = false;
        this.loadCategories();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.deleteConfirm.loading = false;
    },
    async onSubmitForm() {
      this.form.loading = true;

      const [, error] = await this.request(this.form.type === 'create' ? '/api/v1/article-categories' : `/api/v1/article-categories/${this.form.editId}`, {
        method: this.form.type === 'create' ? 'post' : 'patch',
        data: {
          data: {
            type: 'article-categories',
            ...(this.form.type === 'create' ? {} : { id: this.form.editId }),
            attributes: {
              name: this.form.name,
            },
          },
        },
      });

      if (!error) {
        this.form.visible = false;
        this.loadCategories();
      } else {
        this.createAlert({
          data: error.message,
          status: 'error',
        });
      }

      this.form.loading = false;
    },
    async loadCategories(params) {
      this.loadingCategories = true;

      const [res, err] = await this.request('/api/v1/article-categories', {
        params: {
          'page[size]': 5,
          'sort': '-id',
          ...params,
        },
      });

      if (!err) {
        this.categories = res;
      }

      this.loadingCategories = false;
    },
  },
};
</script>
